import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.dental;

export const getDentalPlanSelector = createSelector(getState, (state) => state.dentalPlans);
